import React from 'react';

export interface Props {
  children: React.ReactNode | React.ReactNode[];
  label: string;
  highlighted?: boolean;
}

export const GridContent: React.FC<Props> = () => {
  return null;
};
